import AdvertisingGdprV3ViewState from '../../store/schema/AdvertisingGdprV3ViewState';
import getFallbackValueIfNull from '../../utils/getFallbackValueIfNull';
import { EUEmailAdsOptions, euEmailAdsOwsOptionsFeatureType } from 'owa-ads-ows-options';
import { getOptionsStore } from '../../store/Store';
import {
    getOptionsForFeature,
    GdprAdsV3Options,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-options';

export default function getAdvertisingOptions() {
    const savedOptions = getOptionsForFeature<GdprAdsV3Options>(OwsOptionsFeatureType.GdprAdsV3);
    const euAdsSavedOptions = getOptionsForFeature<EUEmailAdsOptions>(
        euEmailAdsOwsOptionsFeatureType
    );

    const store = getOptionsStore();

    const options = store && (store.activeViewState as AdvertisingGdprV3ViewState);

    return {
        allStoreAndAccessDevice: getFallbackValueIfNull(
            options?.allStoreAndAccessDevice,
            savedOptions?.encodedTCString ? savedOptions.allStoreAndAccessDevice : undefined
        ),

        allowDevelopAndImproveProduct: getFallbackValueIfNull(
            options?.allowDevelopAndImproveProduct,
            savedOptions?.encodedTCString ? savedOptions.allowDevelopAndImproveProduct : undefined
        ),

        allowPersonalisedAds: getFallbackValueIfNull(
            options?.allowPersonalisedAds,
            savedOptions?.encodedTCString ? savedOptions.allowPersonalisedAds : undefined
        ),

        allowPersonalisedAdsSelectBasicAd: getFallbackValueIfNull(
            options?.allowPersonalisedAdsSelectBasicAd,
            savedOptions?.encodedTCString
                ? savedOptions.allowPersonalisedAdsSelectBasicAd
                : undefined
        ),

        allowPersonalisedAdsApplyMarketResearch: getFallbackValueIfNull(
            options?.allowPersonalisedAdsApplyMarketResearch,
            savedOptions?.encodedTCString
                ? savedOptions.allowPersonalisedAdsApplyMarketResearch
                : undefined
        ),

        allowPersonalisedAdsMeasureContentPerformance: getFallbackValueIfNull(
            options?.allowPersonalisedAdsMeasureContentPerformance,
            savedOptions?.encodedTCString
                ? savedOptions.allowPersonalisedAdsMeasureContentPerformance
                : undefined
        ),

        allowPersonalisedAdsSelectPersonalisedAds: getFallbackValueIfNull(
            options?.allowPersonalisedAdsSelectPersonalisedAds,
            savedOptions?.encodedTCString
                ? savedOptions.allowPersonalisedAdsSelectPersonalisedAds
                : undefined
        ),

        allowPersonalisedAdsMeasureAdPerf: getFallbackValueIfNull(
            options?.allowPersonalisedAdsMeasureAdPerf,
            savedOptions?.encodedTCString
                ? savedOptions.allowPersonalisedAdsMeasureAdPerf
                : undefined
        ),

        allowPersonalisedAdsSelectPersonalisedContent: getFallbackValueIfNull(
            options?.allowPersonalisedAdsSelectPersonalisedContent,
            savedOptions?.encodedTCString
                ? savedOptions.allowPersonalisedAdsSelectPersonalisedContent
                : undefined
        ),

        allowPersonalisedAdsCreatePersonalisedContentProfile: getFallbackValueIfNull(
            options?.allowPersonalisedAdsCreatePersonalisedContentProfile,
            savedOptions?.encodedTCString
                ? savedOptions.allowPersonalisedAdsCreatePersonalisedContentProfile
                : undefined
        ),

        allowPersonalisedAdsCreatePersonalisedAdsProfile: getFallbackValueIfNull(
            options?.allowPersonalisedAdsCreatePersonalisedAdsProfile,
            savedOptions?.encodedTCString
                ? savedOptions.allowPersonalisedAdsCreatePersonalisedAdsProfile
                : undefined
        ),

        allowPreciseGeoDataAndIdentifyDevice: getFallbackValueIfNull(
            options?.allowPreciseGeoDataAndIdentifyDevice,
            savedOptions?.encodedTCString
                ? savedOptions.allowPreciseGeoDataAndIdentifyDevice
                : undefined
        ),

        allowPreciseGeoDataAndIdentifyDeviceScanDevice: getFallbackValueIfNull(
            options?.allowPreciseGeoDataAndIdentifyDeviceScanDevice,
            savedOptions?.encodedTCString
                ? savedOptions.allowPreciseGeoDataAndIdentifyDeviceScanDevice
                : undefined
        ),

        allowPreciseGeoDataAndIdentifyDeviceGeoData: getFallbackValueIfNull(
            options?.allowPreciseGeoDataAndIdentifyDeviceGeoData,
            savedOptions?.encodedTCString
                ? savedOptions.allowPreciseGeoDataAndIdentifyDeviceGeoData
                : undefined
        ),

        disselectedVendorId: getFallbackValueIfNull(
            options?.disselectedVendorId,
            savedOptions?.encodedTCString ? savedOptions.disselectedVendorId : undefined
        ),

        selectedVendorId: getFallbackValueIfNull(
            options?.selectedVendorId,
            savedOptions?.encodedTCString ? savedOptions.selectedVendorId : undefined
        ),

        vendorList: options?.vendorList,

        encodedTCString: savedOptions?.encodedTCString,

        optInBit: getFallbackValueIfNull(options?.optInBit, euAdsSavedOptions?.optInBit ?? null),
    };
}
